export const selectGroups = (state) => state.groups.all || [];
export const selectCurrentGroup = (state) => state.groups?.current || null;
export const selectIsLoading = (state) => state.groups.isLoading;
